/**
 * AddressInput1 — address autocomplete backed by the Mapbox Places API
 * (api/getPlaces.js). This is the only variant used by the forms —
 * AddressInput (Google-based) and AddressInput2 (Mapbox) are unused.
 *
 * Emits { address, latLng: { lat, lng }, countryCode } via onSelect when a
 * suggestion is picked; free typing emits a null latLng, which is how form
 * validators distinguish a verified address from raw text (green check =
 * verified).
 */
import React, { useState, useEffect, /*useRef*/ } from "react";
import { Input, Menu, Dropdown } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import getPlaces from "../../api/getPlaces";
import "./AddressInput.scss";

const AddressInput1 = ({ value, onChange, onSelect, ...props }) => {
  const [address, setAddress] = useState(value?.address ?? "");
  const [valid, setValid] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  // const [initial, setInitial] = useState({address, valid: (!!value?.latLng?.lat && !!value?.latLng?.lng)});
  // const menuRef = useRef(null);
  
  const queryPlaces = async (query) => {
    try {
      // Vara Volvofabriken 1, 534 91 Vara, Sweden
      // setSuggestions([
      //   {place_name: "Vara Volvofabriken 1, 534 91 Vara, Sweden", center: [58.242316, 12.995785]},
      //   {place_name: "Exempel 1", center: [58, 12]},
      // ]);
      const res = await getPlaces(query);
      setSuggestions(res.features);
    } catch (error) {
      console.error("Error querying places:", error);
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setAddress(value);
    queryPlaces(value);
    setValid(false);
    onChange &&
      onChange({address:value,latLng:{lat:null,lng:null}});
  };
  /*const onBlur = () => {
    console.log("menuRef:", menuRef.current);
    if (menuRef.current && menuRef.current.contains(document.activeElement)) return;
    setSuggestions([]);
    // console.log("lastValidValue:", initial.address, "initialValid:", initial.valid);
    if (!valid) {
      setAddress(initial.address);
      setValid(initial.valid);
    }
  }*/

  const handleSelectSuggestion = ({ place_name, center, context = [] }) => {
    const address = {
      address: place_name,
      latLng: {
        lng: center[0],
        lat: center[1],
      },
      countryCode: context[context.length - 1]?.short_code,
    };
    setAddress(place_name);
    setValid(true);
    // setInitial({...initial, address:place_name});
    onSelect && onSelect(address);
    setSuggestions([]);
  };

  useEffect(() => {
    setAddress(value?.address);
    // setInitial({...initial, address:value?.address});
    if (value?.latLng?.lat && value?.latLng?.lng) {
      setValid(true);
      // setInitial({...initial, valid:true});
    };
  }, [value]);

  const menu = suggestions?.length ? (
    <Menu /*ref={menuRef}*/>
      {suggestions.map((suggestion, index) => {
        const className = suggestion.active
          ? "suggestion-item--active"
          : "suggestion-item";
        const style = suggestion.active
          ? {
              backgroundColor: "#fafafa",
              cursor: "pointer",
            }
          : {
              backgroundColor: "#ffffff",
              cursor: "pointer",
            };
        return (
          <Menu.Item key={index}>
            <div
              className={className}
              style={style}
              key={suggestion.place_name}
              onClick={() => handleSelectSuggestion(suggestion)}
            >
              <span>{suggestion.place_name}</span>
            </div>
          </Menu.Item>
        );
      })}
    </Menu>
  ) : (
    <></>
  );

  return (
    <Dropdown overlay={menu} placement="bottomLeft" visible={true}>
      <Input
        onChange={handleChange}
        // onBlur={onBlur}
        value={address}
        autoComplete="no"
        suffix={
          // valid && address ? (
          //   <CheckCircleFilled style={{ color: "#43C1C2" }} />
          // ) : (
          //   ""
          // )
          <CheckCircleFilled style={{ color: valid && address ? "#43C1C2" : "transparent" }} />
        }
        {...props}
      />
    </Dropdown>
  );
};

export default AddressInput1;
